function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.0136 35C11.7218 35 5 28.2782 5 19.9864C5 12.0003 11.2353 5.47061 19.1032 5C17.3345 6.98886 16.2602 9.60878 16.2602 12.4796C16.2602 18.6985 21.3015 23.7398 27.5204 23.7398C30.3912 23.7398 33.0111 22.6655 35 20.8968C34.5294 28.7647 27.9996 35 20.0136 35Z",
  fill: "#888888"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 29.5,
  y: 5.55078,
  width: 7,
  height: 7,
  transform: "rotate(45 29.5 5.55078)",
  fill: "#C4C4C4"
});

var SvgNight = function SvgNight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/night.f6414e88.svg";
export { ForwardRef as ReactComponent };